import { API_URL_WS_FORMULAIRE } from '@amo/core/constants/constants.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFormValues } from 'redux-form';
import { SAVE_DEVIS, postSaveDevis } from '../../../../../redux/actions/app/saveDevis/saveDevis.actions';
import {
    getCanalDemandeTarifInit,
    getIsComparateurApporteur,
    getNameWhitelabel,
    getParrainageEmailInit,
    getParrainageTelPortableInit,
    getToken
} from '../../../../../redux/selectors/init/init.selectors';
import { getErrorEntity, getLoadingEntity, getStep } from '../../../../../redux/selectors/ui/ui.selectors';
import { getVehicule } from '../../../../../redux/selectors/vehicule/vehicule.selectors';
import Recontact from './Recontact';

const mapStateToProps = (state) => {
    return {
        saveDevisLoading: getLoadingEntity(state, SAVE_DEVIS),
        saveDevisError: getErrorEntity(state, SAVE_DEVIS),
        querySaveDevis: `${API_URL_WS_FORMULAIRE}/save_devis/${getToken(state)}`,
        data: getFormValues('devis-direct')(state),
        step: getStep(state),
        nameWhitelabel: getNameWhitelabel(state),
        vehicule: getVehicule(state),
        isComparateur: getIsComparateurApporteur(state),
        canal: getCanalDemandeTarifInit(state),
        emailParrainage: getParrainageEmailInit(state),
        telPortableParrainage: getParrainageTelPortableInit(state),
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            postSaveDevis,
        },
        dispatch,
    );

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { data, step, querySaveDevis } = stateProps;
    const { postSaveDevis } = dispatchProps;

    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        postSaveDevis: () => postSaveDevis({ form: data, query: querySaveDevis, step }),
    };
};

const RecontactContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(Recontact);

export default RecontactContainer;
